"use strict";
// 性能优化相关
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = exports.throttle = void 0;
/**
 * @description 节流函数
 * 防止触发频率过高引起异常情况 只支持addEventListener监听器触发
 * 一段时间内只触发一次
 * 暂不支持在react FC中直接使用 后期会出一个hooks的包
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {function} callBack | 可以执行的回调
 * @param {number} wait | 等待时间 单位毫秒 默认 300
 * @returns {(e:T) => void}
 * @example
 * // 监听浏览器滚动事件
 * window.addEventListener('scroll', throttle((e: Event) => console.log('执行了', e), 300));
 *
 * // 监听某个元素的点击事件 如秒杀商品等情况
 *
 * // 在react中
 * const ref = useRef<HTMLELEMENT>(null);
 * ref.current.addEventListener('click', throttle((e: Event) => console.log('执行了', e), 300));
 *
 * // 在vue中
 * this.$ref.el.addEventListener('click', throttle((e: Event) => console.log('执行了', e), 300));
 *
 *
 * // 在js中
 * document.getElementById('el').addEventListener('click', throttle((e: Event) => console.log('执行了', e), 300));
 */
var throttle = function (callBack, wait) {
    if (wait === void 0) { wait = 300; }
    var now = 0;
    return function (e) {
        if (now + wait <= Date.now()) {
            callBack.call(_this, e);
            now = Date.now();
        }
    };
};
exports.throttle = throttle;
/**
 *
 * @description 防抖函数
 * 延迟一段时间后触发 在此期间如果继续触发 则重新计时 只支持addEventListener监听器触发
 * 暂不支持在react FC中直接使用 后期会出一个hooks的包
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {function} callBack | 可以执行的回调
 * @param {number} wait | 等待时间 单位毫秒 默认 300
 * @returns {(e:T) => void}
 * @example
 * // 在react中
 * const ref = useRef<HTMLELEMENT>(null);
 * ref.current.addEventListener('click', debounce((e: Event) => console.log('执行了', e), 300));
 *
 * // 在vue中
 * this.$ref.el.addEventListener('click', debounce((e: Event) => console.log('执行了', e), 300));
 *
 * // 在js中
 * document.getElementById('el').addEventListener('click', debounce((e: Event) => console.log('执行了', e), 300));
 */
var debounce = function (callBack, wait) {
    if (wait === void 0) { wait = 300; }
    var timeHandle = null;
    return function (e) {
        if (timeHandle !== null) {
            clearTimeout(timeHandle);
        }
        timeHandle = setTimeout(function () {
            callBack.call(_this, e);
            timeHandle = null;
        }, wait);
    };
};
exports.debounce = debounce;
